module.exports = __webpack_public_path__ + "img/circles.3b1930f7.svg";